<div class="intervention-dialog" cdkScrollable>
    @if(this.title){
    <h3 mat-dialog-title>{{this.title}}</h3>
    } @else {
    <h2 mat-dialog-title>Report intervention with no deviation</h2>
    }
    <form [formGroup]="dialogFormGroup">
        <mat-dialog-content>
            <mat-form-field>
                <mat-label>HW Version</mat-label>
                <input type="string" id="hw_version" placeholder="Select HW version" aria-label="HW version" required
                    matInput formControlName="hwVersion" [matAutocomplete]="auto">
                @if (hwVersion.hasError('required')) {
                <mat-error>HW version is <strong>required</strong></mat-error>
                }
                <mat-autocomplete #auto="matAutocomplete">
                    @for (option of filteredHwVersions | async; track option) {
                    <mat-option [value]="option">{{option}}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field>
                <mat-label>SW Version</mat-label>
                <input type="string" id="sw_version" placeholder="Select SW version" aria-label="SW version" required
                    matInput formControlName="swVersion" [matAutocomplete]="swAuto">
                @if (swVersion.hasError('required')) {
                <mat-error>SW version is <strong>required</strong></mat-error>
                }
                <mat-autocomplete #swAuto="matAutocomplete">
                    @for (option of filteredSwVersions | async; track option) {
                    <mat-option [value]="option">{{option}}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Customer</mat-label>
                <input type="string" id="customer_input" placeholder="Select customer" aria-label="Customer" required
                    matInput formControlName="customer" [matAutocomplete]="customerAuto">
                @if (customer.hasError('required')) {
                <mat-error>Customer is <strong>required</strong></mat-error>
                }
                <mat-autocomplete #customerAuto="matAutocomplete">
                    @for (option of filteredCustomers | async; track option) {
                    <mat-option [value]="option">{{option}}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
            <mat-form-field>
                <mat-label>Usecase</mat-label>
                <input type="string" id="usecase" placeholder="Usecase" aria-label="Usecase" matInput
                    formControlName="usecase" autofocus>
                @if (usecase.hasError('required')) {
                <mat-error>Usecase is <strong>required</strong></mat-error>
                }
            </mat-form-field>
            <mat-form-field>
                <mat-label>Cart</mat-label>
                <input type="string" id="cart" placeholder="Cart" aria-label="Cart" matInput formControlName="cart"
                    autofocus>
            </mat-form-field>
            @if (displayIssueGroup) {
            <mat-form-field>
                <mat-label>Issue-group</mat-label>
                <input type="string" id="issueGroup" placeholder="Select issue-group" aria-label="Issue-group" matInput
                    formControlName="issueGroup" [matAutocomplete]="issueGroupAuto" autofocus>
                @if (issueGroup.hasError('required')) {
                <mat-error>Issue-group is <strong>required</strong></mat-error>
                }
                <mat-autocomplete #issueGroupAuto="matAutocomplete">
                    @for (option of filteredIssueGroups | async; track option) {
                    <mat-option [value]="option">{{option}}</mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>

            }
            <mat-form-field id="downtime-field" style="width: 80%">
                <mat-label>Minutes used to resolve</mat-label>
                <input type="number" id="min_downtime" required matInput formControlName="minDowntime" required
                    placeholder="Minutes used to resolve...">
                    @if (minDowntime.hasError('required')) {
                    <mat-error>Minutes are <strong>required</strong></mat-error>
                    }
                    @else if (minDowntime.hasError('min')) {
                    <mat-error>Minutes must be larger than 0</mat-error>
                    }
            </mat-form-field>
            <mat-form-field id="description_input" class="description">
                <mat-label>Description</mat-label>
                <textarea matInput class="text-area" placeholder="Ex. Robot says 'wheels disconnected'..."
                    formControlName="description"></textarea>
                <mat-hint>Minimum 10 characters</mat-hint>
                @if (description.hasError('required')) {
                <mat-error>Description is <strong>required</strong></mat-error>
                }
                @else if (description.hasError('minlength')) {
                <mat-error>Description must be at least <strong>10 characters</strong></mat-error>
                }
            </mat-form-field>

            <div id="actions-section">
                <h2>
                    Actions
                </h2>
                @if (actions.hasError('required')) {
                <mat-error>Minimum one action is <strong>required</strong></mat-error>
                }
                @for(action of actions.value; track action){
                <div class="action-card mat-elevation-z1">
                    <div class="card-content">
                        {{ action }}
                    </div>
                    <div class="card-delete">
                        <button mat-icon-button color="warn" (click)="deleteAction($index)" class="trash-btn"
                            align="end">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>
                }
                <div id="add-action-section">
                    <form [formGroup]="actionFormGroup" id="action-form">
                        <mat-form-field>
                            <mat-label>Add common action</mat-label>
                            <mat-select id="common-action" formControlName="commonAction">
                                @for (action of commonActionHints; track action) {
                                <mat-option [value]="action">{{action.action}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        @if(commonAction.value.multiWheel) {
                        <mat-form-field>
                            <mat-label>Select Wheel</mat-label>
                            <mat-select id="select-wheel" formControlName="wheel">
                                @for (option of ["FL", "FR", "BL", "BR"]; track option) {
                                <mat-option [value]="option">{{option}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        }
                        <mat-form-field>
                            <mat-label>Add custom actions</mat-label>
                            <textarea matInput id="custom-action" placeholder="Add custom actions..."
                                formControlName="customAction"></textarea>
                        </mat-form-field>
                        <button mat-stroked-button id="submit-action" (click)="submitAction()"
                            [disabled]="!actionFormGroup.valid">Add Action</button>
                    </form>
                </div>
            </div>
        </mat-dialog-content>

    </form>
    <mat-dialog-actions>
        <button mat-stroked-button (click)="onNoClick()" id="cancelButton">Cancel</button>
        <button mat-flat-button (click)="onOKClick()" id="okButton">Submit Intervention</button>
    </mat-dialog-actions>
</div>
